import {convertHeightToPx} from '../converters/height'
import type {CalculateParams} from '../types'
import {getValue} from '../utils'

export const calculateHeight = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.height(compRef) !== undefined) {
        return
    }

    const {componentLayout} = layoutData
    const {height} = componentLayout ?? {}

    if (!height?.type) {
        set.height(compRef, convertHeightToPx.auto(calculateParams))
        return
    }

    const heightInPx = convertHeightToPx[height.type]({
        ...calculateParams,
        value: getValue(height)
    })
    set.height(compRef, heightInPx)
}
